/**
 * Query key utilities for config hooks
 * Keys match backend controller method names
 */
export const configKeys = {
  getConfig: () => ["config", "getConfig"] as const,
} as const
